const nestedTHead = "_275n1cn9ve7";

export { nestedTHead };
import "./table.nested-thead.style.linaria.module.css";
//# sourceMappingURL=table.nested-thead.style.js.map
